<script setup lang="ts">
import 'vue3-carousel/dist/carousel.css'

import { Carousel, Slide } from 'vue3-carousel'

import { EvmHomeBlockInfo } from '~/api/repository'
import Block from '~/components/block/Block.vue'

interface IProps {
  list: Array<EvmHomeBlockInfo>
  maxTransactionCount: number
  isFirst: boolean
  isSameLatestBlock: boolean
}

const props = defineProps<IProps>()

const delayPadding = 0.11

const getHeight = (transactionCount: string) => Math.ceil(parseInt(transactionCount) / props.maxTransactionCount * 100)

const blockList = ref<Array<EvmHomeBlockInfo>>([ ...props.list ].reverse())
const carousel = ref()
const animationKey = ref(0)

const emptyBlock: EvmHomeBlockInfo = { BNO: '', TRXCNT: '0' }

let timerId: NodeJS.Timeout

const moveCarousel = () => {
  animationKey.value++
  if (!carousel.value) {
    return
  }
  carousel.value.next()
  carousel.value.updateSlideWidth()
}

const removeExpiredBlock = () => {
  blockList.value.shift()
  clearTimeout(timerId)
}

watchEffect(async () => {
  if (props.isSameLatestBlock) {
    return
  }
  blockList.value = [ ...props.list, emptyBlock ].reverse()
  await nextTick(moveCarousel)
  timerId = setTimeout(removeExpiredBlock, 300)
})

onBeforeUnmount(() => {
  if (timerId) {
    clearTimeout(timerId)
  }
})
</script>

<template>
  <Carousel
    :wrap-around="false"
    :items-to-show="5"
    snap-align="center"
    dir="rtl"
    :mouse-drag="false"
    :touch-drag="false"
    ref="carousel"
  >
    <Slide
      v-for="(block, index) in blockList"
      :key="`${animationKey}-${block.BNO}`"
      class="pb-4 pt-2"
    >
      <Block
        :block="block"
        :height="getHeight(block.TRXCNT)"
        :play-animation="!isSameLatestBlock"
        :delay="((isFirst ? 4 : 10) - index) * delayPadding"
        :is-latest="isFirst && index === blockList.length - 1"
      />
    </Slide>
  </Carousel>
</template>

<style scoped>

</style>